<template>
  <BaseEmptyState>
    <template v-slot:icon>
      <ExclamationCircleIcon class="text-danger" />
    </template>
    <template v-slot:title>
      <slot name="title">
        <h2>{{ title }}</h2>
      </slot>
    </template>
    <template v-slot:content>
      <slot name="default">
        <p>{{ message }}</p>
      </slot>
    </template>
  </BaseEmptyState>
</template>

<script>
import { defineComponent } from 'vue';
import BaseEmptyState from '@/components/library/emptyStates/BaseEmptyState.vue';
import { ExclamationCircleIcon } from '@/components/icons/fontIcons';
import i18n from '@/locales';

export default defineComponent({
  name: 'ErrorState',
  components: {
    BaseEmptyState,
    ExclamationCircleIcon,
  },
  props: {
    title: {
      type: String,
      required: false,
      default() {
        return i18n.t('ui.common.states.errorState.title');
      },
    },
    message: {
      type: String,
      required: false,
      default() {
        return i18n.t('ui.common.states.errorState.message');
      },
    },
  },
});
</script>
